<template>
	<v-container>
		<v-row dense>
			<v-col class="text-center" cols="12">
				<div class="title primary--text">TeleRetina - Users Statistics</div>
			</v-col>

			<v-col cols="12" sm="8">
				<v-row dense>
					<v-col cols="12">
						<v-card :loading="chartData == null">
							<v-card-title primary-title style="text-align: center">
								<v-col cols="12" class="pa-0 subtitle-1">Users</v-col>
							</v-card-title>
							<v-card-text v-if="chartData">
								<bar-chart :chart-data="chartData" :options="options"></bar-chart>
							</v-card-text>
						</v-card>
					</v-col>
				</v-row>
			</v-col>

			<v-col cols="12" sm="4">
				<v-row dense>
					<v-col cols="12">
						<v-card :loading="mostActiveUser == null">
							<v-card-title class="title">Most Active User</v-card-title>
							<v-card-text v-if="mostActiveUser">
								<v-row no-gutters>
									<v-col cols="auto" class="font-weight-black">{{ mostActiveUser.name }}</v-col>
									<v-col class="text-end">{{ mostActiveUser.times }} Logins</v-col>
								</v-row>
							</v-card-text>
						</v-card>
					</v-col>
					<v-col cols="12">
						<v-card>
							<v-card-title class="title">Most Monthly Activity</v-card-title>
							<v-card-text>
								<v-row no-gutters>
									<v-col cols="auto" class="pa-0 font-weight-black">Novermber 2017</v-col>
									<v-col class="text-end">350 Users</v-col>
								</v-row>
							</v-card-text>
						</v-card>
					</v-col>
				</v-row>
			</v-col>
		</v-row>
	</v-container>
</template>

<script>
const axios = require("axios");

import BarChart from "@/components/charts/AppBarChart.js";

export default {
	components: {
		BarChart
	},
	mixins: [
		require("@/mixins/backend-mixin").default,
		require("@/mixins/router-mixin").default,
		require("@/mixins/utilities-mixin").default
	],
	data() {
		return {
			chartData: null,
			options: {
				responsive: true,
				maintainAspectRatio: false,
				scales: {
					yAxes: [
						{
							ticks: {
								beginAtZero: true
							}
						}
					],
					xAxes: [
						{
							gridLines: {
								display: false
							}
						}
					]
				},
				legend: {
					display: false
				}
			},
			mostActiveUser: null
		};
	},
	mounted() {
		this.fillData();
		this.getData();
	},
	methods: {
		fillData() {
			var data = [
				{
					data: [
						this.getRandomInt(),
						this.getRandomInt(),
						this.getRandomInt(),
						this.getRandomInt(),
						this.getRandomInt(),
						this.getRandomInt(),
						this.getRandomInt(),
						this.getRandomInt(),
						this.getRandomInt(),
						this.getRandomInt(),
						this.getRandomInt(),
						this.getRandomInt()
					],
					backgroundColor: this.getColors(12, 0.6),
					borderColor: this.getColors(12, 0.6),
					hoverBackgroundColor: this.getColors(12, 1),
					borderWidth: 1
				}
			];

			this.chartData = {
				labels: [
					"January",
					"February",
					"March",
					"April",
					"May",
					"June",
					"July",
					"August",
					"September",
					"October",
					"November",
					"December"
				],
				datasets: data
			};
		},
		getData() {
			this.getMostActiveUser();
		},
		getMostActiveUser() {
			const url = this.BACKEND_URL + "/api/mostActivePatient";
			const thisVue = this;

			axios
				.get(url)
				.then(response => {
					console.log(response);
					if (response.status == 200) {
						thisVue.mostActiveUser = response.data[0];
					}
				})
				.catch(error => {
					console.error(error);
				});
		}
	}
};
</script>